.row {
  border-bottom: 1px solid var(--gray-border);
}

.row:last-child {
  border-bottom: none;
}

.header {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 0;
  background: none;
  text-align: left;
  font-weight: 400;
  font-size: 13px;
  border-radius: 0;
  cursor: pointer;
}

.icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

.icon.pass {
  background: var(--green-bg);
  color: var(--green);
}

.icon.warn {
  background: var(--yellow-bg);
  color: var(--yellow);
}

.icon.fail {
  background: var(--red-bg);
  color: var(--red);
}

.icon.error {
  background: var(--orange-bg);
  color: var(--orange);
}

.icon.skipped,
.icon.muted {
  background: var(--gray-bg);
  color: var(--gray-text);
}

.name {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 5px;
}

.infoWrap {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.infoIcon {
  width: 14px;
  height: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 9px;
  font-weight: 700;
  font-style: italic;
  color: var(--gray-text);
  border: 1px solid var(--gray-border);
  cursor: help;
  flex-shrink: 0;
  
}

.tooltip {
  display: none;
  position: absolute;
  bottom: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  background: var(--text);
  color: var(--white);
  font-size: 11px;
  font-weight: 400;
  font-style: normal;
  line-height: 1.4;
  padding: 6px 10px;
  border-radius: var(--radius);
  white-space: pre-line;
  width: 240px;
  z-index: 10;
  pointer-events: none;
}

.tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 4px solid transparent;
  border-top-color: var(--text);
}

.infoWrap:hover .tooltip {
  display: block;
}

.status {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.status.pass { color: var(--green); }
.status.warn { color: var(--yellow); }
.status.fail { color: var(--red); }
.status.error { color: var(--orange); }
.status.skipped,
.status.muted { color: var(--gray-text); }

.chevron {
  font-size: 10px;
  color: var(--gray-text);
  width: 12px;
}

.detail {
  padding: 0 0 10px 28px;
  font-size: 12px;
}

.message {
  font-weight: 500;
  color: var(--text);
  font-size: 13px;
  margin-bottom: 8px;
}


.remediation {
  color: var(--text);
  background: var(--red-bg);
  padding: 6px 8px;
  border-radius: var(--radius);
  border-left: 3px solid var(--red);
  font-size: 12px;
}

/* Gray eyebrow above the fix-it text, mirroring the OBSERVED label's framing. */
.remediationLabel {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--gray-text);
  opacity: 0.6;
  margin-bottom: 3px;
}

.remediationWarn {
  color: var(--text);
  background: var(--yellow-bg);
  padding: 6px 8px;
  border-radius: var(--radius);
  border-left: 3px solid var(--yellow);
  font-size: 12px;
}

.detailTableWrap {
  display: inline-block;
  border: 1px solid var(--gray-border);
  border-radius: var(--radius);
  overflow: hidden;
  margin: 0 0 10px 0;
  max-width: 100%;
}

.detailTable {
  border-collapse: collapse;
  font-size: 11px;
  width: auto;
}

.detailTh {
  text-align: left;
  font-weight: 600;
  color: var(--gray-text);
  padding: 5px 14px 5px 8px;
  text-transform: uppercase;
  font-size: 10px;
  letter-spacing: 0.04em;
  background: var(--gray-bg);
  border-bottom: 1px solid var(--gray-border);
}

.detailLabel {
  color: var(--gray-text);
  padding: 4px 12px 4px 8px;
  white-space: nowrap;
  border-bottom: 1px solid var(--gray-border);
}

.detailLabelPass {
  color: var(--green);
  font-weight: 500;
  padding: 4px 12px 4px 8px;
  white-space: nowrap;
  border-bottom: 1px solid var(--gray-border);
}

.detailLabelFail {
  color: var(--red);
  font-weight: 500;
  padding: 4px 12px 4px 8px;
  white-space: nowrap;
  border-bottom: 1px solid var(--gray-border);
}

.detailValue {
  color: var(--text);
  padding: 4px 14px 4px 8px;
  font-variant-numeric: tabular-nums;
  border-bottom: 1px solid var(--gray-border);
}

.detailNa {
  color: var(--gray-text) !important;
  font-style: italic;
}

.cellPass {
  background: var(--green-bg);
  color: var(--green) !important;
  font-weight: 500;
}

.cellWarn {
  background: var(--yellow-bg);
  color: var(--yellow) !important;
  font-weight: 500;
}

.cellFail {
  background: var(--red-bg);
  color: var(--red) !important;
  font-weight: 500;
}

.cellError {
  background: var(--orange-bg);
  color: var(--orange) !important;
  font-weight: 500;
}

.detailLink {
  color: var(--blue-light);
  text-decoration: none;
}

.detailLink:hover {
  text-decoration: underline;
}

/* Muted checks: run and show their real status but do not affect the overall disposition. */
.mutedRow {
  opacity: 0.72;
}

.mutedBadge {
  display: inline-block;
  margin-left: 8px;
  padding: 1px 6px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--gray-text);
  background: var(--gray-bg);
  border: 1px solid var(--gray-border);
  border-radius: var(--radius);
  vertical-align: middle;
}

.mutedNote {
  color: var(--gray-text);
  background: var(--gray-bg);
  padding: 6px 8px;
  border-radius: var(--radius);
  border-left: 3px solid var(--gray-text);
  font-size: 12px;
  margin-bottom: 8px;
}

/* Muted rows: neutralize the status icon + word so PASS/WARN/FAIL doesn't read as
   a green/amber/red result that counts. The real status text is still shown. */
.mutedIcon {
  background: var(--gray-bg);
  color: var(--gray-text);
}

.mutedStatus {
  color: var(--gray-text);
}
